import Block from '../../../components/Block/Block'
import FeedbackForm from '../../../components/FeedbackForm/FeedbackForm'
import FadeIn from '../../../components/FadeIn/FadeIn'

import style from './feedbackformblock.module.scss'

const FeedbackFormBlock = () => {
    return (
        <Block
            flexDirection="column"
            justifyContent="center"
            alignItems="start"
            width="75%"
            height='fit-content'
            background="rgba(255, 255, 255, 0.85)"
            header='ОБРАТНАЯ СВЯЗЬ'
        >
            <FadeIn>
            <div className={style.content}>
                <FeedbackForm />
            </div>
            </FadeIn>
        </Block>
    )
}

export default FeedbackFormBlock